class CartDiscountInput extends HTMLElement {
  constructor() {
    super();
  }
  getCart() {
    fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'Get',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      return response.json();
    })
    .then(response => {
      if(response.discount_codes) {
        this.discount_codes = response.discount_codes;
      }
      this.init();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
  removeDiscountCode(code) {
    if(code) {
      this.discount_codes = this.discount_codes.filter(discount_code => discount_code.code.toUpperCase() !== code);
      const codes_to_apply = this.discount_codes.map(discount_code => discount_code.code);
      window.cart.setDiscount(codes_to_apply.join(','));
    }
  }
  submitDiscounts() {
    if(this.input && window.cart) {
      const value = this.input.value?.trim()?.toUpperCase();
      if(value) {
        const has_value = this.discount_codes.find(discount_code => discount_code.code.toUpperCase() === value);
        if(!has_value) {
          const codes_to_apply = this.discount_codes.map(discount_code => discount_code.code);
          codes_to_apply.push(value);
          window.cart.setDiscount(codes_to_apply.join(','));
        }
      }
      this.input.value = '';
    }
  }
  init() {
    // render active discounts as list
    if(this.codes_wrapper) {
      const icon = `
        <svg aria-hidden="true" focusable="false" role="presentation" class="" viewBox="0 0 14 14" stroke="black" stroke-width="1" style="width: 12px;height: 12px;">
          <g fill="none">
            <path d="M2.625.79H7l6.125 6.124M5.325 2.54H1.75a.875.875 0 0 0-.875.874V6.99c0 .232.092.455.256.619l5.344 5.345a.875.875 0 0 0 1.438-.312l.837-2.227 2.228-.836a.875.875 0 0 0 .311-1.438L5.944 2.795a.874.874 0 0 0-.619-.256zM3.5 4.946">
            </path>
            <path d="M3.5 4.946a.219.219 0 1 0 .001 0H3.5">
            </path>
          </g>
        </svg>
      `
      this.codes_wrapper.innerHTML = '';
      for (const discount_code of this.discount_codes) {
        const dicount_node = document.createElement('div');
        if(discount_code.code) {
          dicount_node.setAttribute('data-code', discount_code.code.trim().toUpperCase());
        }
        dicount_node.classList.add('active-discount');
        if(discount_code.applicable) {
          dicount_node.classList.add('discount-applicable');
        }
        const p_node = document.createElement('p');
        const text_node = document.createTextNode(discount_code.code?.toUpperCase());
        p_node.appendChild(text_node);
        dicount_node.appendChild(p_node);
        dicount_node.insertAdjacentHTML('afterbegin', icon);
        this.codes_wrapper.appendChild(dicount_node);
      }
    }
    // submit discount on enter and on button-click
    this.input?.addEventListener('keypress', e => {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        this.submitDiscounts();
      }
    });
    this.button?.addEventListener('click', e => {
      this.submitDiscounts();
    });
    this.querySelectorAll('[data-code]').forEach(discount_node => {
      discount_node.addEventListener('click', e => {
        const code = discount_node.dataset?.code?.trim()?.toUpperCase();
        this.removeDiscountCode(code);
      })
    });
  }
  connectedCallback() {
    this.input = this.querySelector('input[name="cart-discount-codes"]');
    this.button = this.querySelector('button');
    this.codes_wrapper = this.querySelector('.active-discount-codes');
    this.discount_codes = [];
    document.addEventListener('theme:cart:updated', e => {
      if(e.detail) {
        this.discount_codes = e.detail.discount_codes;
        this.init();
      }
    });
    document.addEventListener('theme:cart:added', e => {
      this.getCart();
    });
    this.getCart();
  }
}
if ("customElements" in window && !customElements.get("cart-discount-input")) {
  customElements.define("cart-discount-input", CartDiscountInput);
}